import {COLORS, FONT_WEIGHTS, UnstyledLink} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Languages as LanguagesType} from '../LanguageCountrySwitch';

export const Languages: FC<{className?: string; languages: LanguagesType}> = ({
  className,
  languages,
}) => {
  return (
    <Wrapper className={className} data-testid="languageCountrySwitchLanguages">
      {languages.map(({isSelected, label, linkTarget, onClick}) => {
        const key = `languageCountrySwitchLanguage-${label}`;

        return (
          <Language
            data-testid={key}
            $isSelected={isSelected}
            key={key}
            openExternalLinkInNewTab={false}
            to={linkTarget!}
            onClick={onClick}
          >
            {label}
          </Language>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
`;

const Language = styled(UnstyledLink)<{$isSelected?: boolean}>`
  align-items: center;
  background: none;
  border-color: ${({$isSelected}) =>
    $isSelected ? COLORS.Black : COLORS.Grey3};
  &&& {
    color: ${COLORS.Black};
  }
  border-radius: 2px;
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  display: flex;
  flex: 1;
  font-size: 0.8125rem;
  font-weight: ${FONT_WEIGHTS.bold};
  height: 2.5rem;
  justify-content: center;
  outline: none;
  transition: border-color 0.3s ease-in-out;
  flex-basis: calc(50% - 0.5rem);
  max-width: calc(50% - 0.5rem);

  &:hover {
    border-color: ${({$isSelected}) =>
      $isSelected ? COLORS.Black : COLORS.Grey1};
  }
`;
